import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';

import reducer, { initialState } from './libraries/reducer.js';
import { StateProvider } from './libraries/stateProvider.jsx';

import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <StateProvider initialState={initialState} reducer={reducer}> 
      <App />
    </StateProvider>
  </React.StrictMode>
);
